import { ref } from "vue";
import { profileNavLinks } from "@/config/siteConfig";

export function useProfile() {
  const profile = ref({
    name: "hlly0x1",
    avatar: require("@/assets/pictures/avatar.jpg"),
    links: profileNavLinks,
  });

  return {
    profile,
  };
}
